import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faHeart, faComment, faShare, faRetweet } from '@fortawesome/free-solid-svg-icons';

const ContentPerformance: React.FC = () => {
  return (
    <section id="content-performance" className="mb-8">
      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-white">En İyi Performans Gösteren İçerikler</h2>
          <div className="flex items-center space-x-4">
            <select className="px-3 py-2 bg-white/5 border border-white/10 rounded-lg text-white text-sm focus:outline-none focus:border-purple-400">
              <option>Tüm Platformlar</option>
              <option>Instagram</option>
              <option>Facebook</option>
              <option>Twitter</option>
            </select>
            <button className="text-white/50 hover:text-white transition-colors">
              <FontAwesomeIcon icon={faFilter} />
            </button>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex items-center space-x-4 p-4 bg-white/5 rounded-xl hover:bg-white/10 transition-colors">
            <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
              <img 
                className="w-full h-full object-cover" 
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/0f02f0ee41-944afbe2449e23e80421.png" 
                alt="social media post about AI analytics dashboard with modern design"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">AI Destekli Sosyal Medya Analitiği</h4>
              <p className="text-white/50 text-sm mb-2">2 gün önce Instagram'da paylaşıldı</p>
              <div className="flex items-center space-x-4 text-sm">
                <span className="text-purple-400">
                  <FontAwesomeIcon icon={faHeart} className="mr-1" />
                  2.4K
                </span>
                <span className="text-blue-400">
                  <FontAwesomeIcon icon={faComment} className="mr-1" />
                  186
                </span>
                <span className="text-green-400">
                  <FontAwesomeIcon icon={faShare} className="mr-1" />
                  92
                </span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold text-white mb-1">4.2%</div>
              <div className="text-green-400 text-sm">Etkileşim Oranı</div>
            </div>
          </div>

          <div className="flex items-center space-x-4 p-4 bg-white/5 rounded-xl hover:bg-white/10 transition-colors">
            <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
              <img 
                className="w-full h-full object-cover" 
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/29f5bf4689-17b7e0e53cf69724e2f4.png" 
                alt="marketing analytics infographic with colorful charts and data visualization"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">2024 İçin 5 Pazarlama Trendi</h4>
              <p className="text-white/50 text-sm mb-2">1 hafta önce Facebook'ta paylaşıldı</p>
              <div className="flex items-center space-x-4 text-sm">
                <span className="text-purple-400">
                  <FontAwesomeIcon icon={faHeart} className="mr-1" />
                  1.8K
                </span>
                <span className="text-blue-400">
                  <FontAwesomeIcon icon={faComment} className="mr-1" />
                  124
                </span>
                <span className="text-green-400">
                  <FontAwesomeIcon icon={faShare} className="mr-1" />
                  67
                </span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold text-white mb-1">3.8%</div>
              <div className="text-green-400 text-sm">Etkileşim Oranı</div>
            </div>
          </div>

          <div className="flex items-center space-x-4 p-4 bg-white/5 rounded-xl hover:bg-white/10 transition-colors">
            <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
              <img 
                className="w-full h-full object-cover" 
                src="https://storage.googleapis.com/uxpilot-auth.appspot.com/86a09cf06b-506fa5f43a1ee8606106.png" 
                alt="behind the scenes office workspace with team collaboration"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">Perde Arkası: AI Ekibimiz</h4>
              <p className="text-white/50 text-sm mb-2">3 gün önce Twitter'da paylaşıldı</p>
              <div className="flex items-center space-x-4 text-sm">
                <span className="text-purple-400">
                  <FontAwesomeIcon icon={faHeart} className="mr-1" />
                  956
                </span>
                <span className="text-blue-400">
                  <FontAwesomeIcon icon={faComment} className="mr-1" />
                  73
                </span>
                <span className="text-green-400">
                  <FontAwesomeIcon icon={faRetweet} className="mr-1" />
                  145
                </span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold text-white mb-1">3.1%</div>
              <div className="text-yellow-400 text-sm">Etkileşim Oranı</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentPerformance;
